module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/media-library-3-6c42647ab223bcea60136f0dd6e69cae.svg";